import { getGenericSocialImage } from '~/images.ts'

export function getMetas({
	url,
	origin,
	title,
	album_name,
	description = `Krzysztof Dąbrowski - Profesjonalny Fotograf i Kamerzysta. Rymanów, Krosno, Sanok, Podkarpacie. Oferujemy Fotografię Ślubną, Sesje Portretowe i Kamerowanie na terenie Podkarpacia.`,
	keywords = 'wideo, video, foto, zdjęcia, film, teledysk, albumy, Orkiestra, orkiestra weselna, przysięga, orkiestra na wesele, sieniawa, głębokie, besko, fotograf, photo, kamerzysta, kamera, camera, wedding, sesja, ślubna, ślub, wedding, wesele, miejscowość, Rymanów, Łazy, Łazy 70, Państwo, Państwo młodzi, młodzi, oczepiny, błogosławieństwo, sprawy weselne, uroczystość, Krzysztof, Dąbrowski, Krzysztof Dąbrowski, Krosno, Rymanów, Sanok, Rzeszów, dojazd, Podkarpacie, plener, reportaż, obrączki, sukienka ślubna, weselne dekoracje, gastronomia weselna, planowanie wesela, zabawy weselne, aranżacja wesela, tort weselny, fotografia plenerowa, filmowanie wesela, konsultacje ślubne, miejsce na wesele, muzyka weselna, kwiaty ślubne, zaproszenia ślubne, organizacja wesela, dekoracje stołów weselnych, menu weselne, suknie ślubne, fryzury ślubne, torty weselne, przyjęcie weselne, noc poślubna, ślub cywilny, fotobudka, zdjecia plenerowe, transport weselny, dekoracje sali weselnej, muzyka na wesele, menu weselne, weselne torty, prezent dla państwa młodych, planowanie ceremonii ślubnej, weselne zaproszenia, suknie na ślub, fryzury ślubne, makijaż ślubny, kwiaty na ślub, fotograf na wesele, kamerzysta na wesele, zaręczyny, prezent na wesele, sala weselna, wynajem samochodów na wesele, organizator wesela, klimatyzowana sala weselna, obsługa weselna, orkiestra weselna na Podkarpaciu, plenerowe sesje ślubne, ślubna oprawa muzyczna, miejsce na ceremonię ślubną, wesele na świeżym powietrzu, przyjęcie weselne w plenerze, muzyka na wesele, lokalne usługi weselne, wesele na Podkarpaciu, oferty weselne Rymanów, najlepszy fotograf ślubny, kamerzysta na wesele w Rymanowie, usługi fotograficzne Podkarpacie, filmowanie wesela Sanok, organizacja wesela Rzeszów, fotograf Krosno, kamerzysta w Bieszczadach, fotografia reportażowa, zdjęcia weselne, usługi fotograficzne w Rzeszowie, filmowanie ślubów w Rymanowie, fotografia artystyczna, foto sesje, plenerowe zdjęcia, fotografia ślubna w Krosnie, weselna fotografia w Besku, podhalańska orkiestra weselna, biesiada weselna w Rymanowie, Państwo Młodzi w Podkarpaciu, eleganckie wesele w Sanoku, weselna dekoracja stołów, catering na wesele w Bieszczadach, organizacja przyjęć weselnych, organizacja ceremonii ślubnej, fajne zabawy na weselu, bukiety ślubne w Rymanowie, zaproszenia na ślub, sale weselne w Krosnie, atrakcje na wesele, weselna muzyka na żywo, kwiaciarnia na ślub, zdjęcia ślubne w Rymanowie, filmowanie wesela w Rzeszowie, przyjęcia weselne w Sanoku, weselne sale w Besku, weselne menu na Podkarpaciu, modne suknie ślubne w Rymanowie, eleganckie fryzury ślubne, torty na wesela w Krosnie, noc poślubna w Bieszczadach, weselny planer, organizacja przyjęcia weselnego, lokalny katering weselny, fotobudki na weselu, fotografie plenerowe w Rzeszowie, transport na wesele w Rymanowie, dekoracje sali weselnej w Besku, muzyka weselna na Podkarpaciu, menu na wesele w Krosnie, weselne torty w Bieszczadach, prezenty na wesele, organizator ceremonii ślubnej, orkiestry weselne, fotobudki na ślubie, fotograf na plenerze, kamerzysta w Rzeszowie, kwiaty ślubne w Rymanowie, zaproszenia ślubne w Krosnie, sale weselne w Besku, aranżacja wesela w Podkarpaciu, torty weselne w Sanoku, przyjęcie weselne na świeżym powietrzu, noc poślubna w Rzeszowie, ślub cywilny w Rymanowie, prezent dla państwa młodych, sala weselna w Krosnie, wynajem samochodów na wesele w Besku, organizator wesela na Podkarpaciu, klimatyzowana sala weselna w Sanoku, obsługa weselna w Bieszczadach',
	image = getGenericSocialImage({
		words: `Krzysztof Dąbrowski | Fotograf i Kamerzysta Weselny`,
		featuredImage: `${origin}/images/about.png`,
	}),
}: {
	url: string
	origin: string
	title?: string
	album_name?: string
	description?: string
	keywords?: string
	image?: string
}) {
	const formattedTitle = `${
		title ? title : 'Fotograf i Kamerzysta Weselny Podkarpackie'
	} | Krzysztof Dąbrowski`

	return [
		{
			name: 'viewport',
			content: 'width=device-width,initial-scale=1,viewport-fit=cover',
		},
		{
			name: 'theme-color',
			content: '#764e2e',
		},
		{
			title: formattedTitle,
		},
		{
			name: 'description',
			content: album_name ? `${album_name} - ${description}` : `${description}`,
		},
		{ name: 'keywords', content: keywords },
		{ name: 'image', content: image },
		{ name: 'og:url', content: url },
		{
			name: 'og:title',
			content: formattedTitle,
		},
		{
			name: 'og:description',
			content: album_name ? `${album_name} - ${description}` : `${description}`,
		},
		{ name: 'og:image', content: image },
		{ name: 'og:site_name', content: `Krzysztof Dąbrowki Fotograf Kamerzysta` },
		{
			name: 'twitter:card',
			content: image ? 'summary_large_image' : 'summary',
		},
		{ name: 'twitter:creator', content: '' },
		{ name: 'twitter:site', content: '' },
		{
			name: 'twitter:title',
			content: formattedTitle,
		},
		{
			name: 'twitter:description',
			content: album_name ? `${album_name} - ${description}` : `${description}`,
		},
		{ name: 'twitter:image', content: image },
		{ name: 'twitter:image:alt', content: title },
	]
}
